<template>
      <div class="full-page">
        <div v-if="done" class="div-block">
          <h1 class="head-40">נשלח אליכם מייל</h1>
          <p>בדקו את המייל והמשיכו בתהליך שם</p>
        </div>
    <div class="div-block">
      <h1 class="head-40">איפוס סיסמא</h1>
      <p class="signin-txt">יש למלא את כתובת המייל ולינק ישלח אליכם</p>
      <input v-on:keyup.13="submit()" type="email" class="text-field w-input" maxlength="256" name="email" data-name="email" v-model="email" placeholder="דוא״ל" id="email" required="">
      <!-- <input  v-on:keyup.13="submit()" type="password" class="text-field w-input" maxlength="256" name="password" data-name="password" v-model="password" placeholder="סיסמא" id="password" required=""> -->
      <a v-on:click="reset()" href="#" class="button w-button">שליחה</a>
      <p class="error">{{error}}</p>

    </div>
  </div>
</template>

<script>
export default {
    name:'login',
        data(){
        return {
          done:false,
      error:'',
      email:'',
      errorArray:{
        "auth/invalid-email":"כתובת מייל לא תקינה",
        "auth/wrong-password":"סיסמה שגויה",
        "auth/user-not-found":"לא נמצא חשבון בכתובת מייל זו"
      }
    }
        },
    mounted(){
      if (this.$parent.user){
          this.$router.push('/alternatives')
      }
    },
    methods:{
      reset(){
        firebase.auth().sendPasswordResetEmail(this.email).then(()=>{
                this.done = true
        }).catch((error)=> {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          this.error = this.errorArray[error.code]
        })
      },
      enter(e){
          if (e.keyCode === 13){
              e.preventDefault();
              this.submit()
          }
      }
    }

}
</script>

<style scoped>
    full-page{
        background: white;
        z-index: 1001;
    }
</style>
